import * as React from "react";

import {
  HeadingMedium,
  LabelMedium,
  ParagraphMedium,
} from "kanopi-components/typography";

import { Block } from "baseui/block";
import { Image } from "kanopi-components/Image";

function Error404() {
  return (
    <Block
      data-testid="error_404"
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Image
        src="404-symbol.svg"
        maxWidth="400px"
        strictRatio
        style={{
          marginTop: "32px",
        }}
      />
      <LabelMedium marginTop="scale1400">Sorry</LabelMedium>
      <HeadingMedium center marginTop="scale500">
        It seems like the page doesn&apos;t exist.
      </HeadingMedium>
      <ParagraphMedium center>
        <a href={"/"}>Back to Home</a>
      </ParagraphMedium>
    </Block>
  );
}

export { Error404 };
